import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-376c8464"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__title" }, " ¡RedCapital ahora es un Sistema de Negociación Electrónica del RADIAN! ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__subtitle q-mt-sm" }, " Para seguir negociando tus facturas sin interrupciones habilítanos en la DIAN ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal__subtitle rc-color" }, " Ve a la sección Radian y carga los documentos solicitados. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: $setup.showModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showModal) = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "custom-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_img, {
                fit: "",
                width: "100%",
                height: "auto",
                alt: "DIAN",
                src: "/images/DianMod.png"
              }),
              _hoisted_1,
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            class: "q-mb-md",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                onClick: $setup.handleConfirm,
                label: "Habilitar ahora",
                class: "orange-btn"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}